"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findAllQuestionsInSections = exports.findOrThrowQuestionById = exports.findQuestionById = exports.findOrThrowQuestionByRootId = exports.findQuestionByRootId = void 0;
var types_1 = require("../../types");
function findQuestionByRootId(sections, rootId) {
    for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
        var section = sections_1[_i];
        for (var _a = 0, _b = section.items; _a < _b.length; _a++) {
            var item = _b[_a];
            if (item.rootId === rootId && types_1.isQuestionDTO(item)) {
                return { question: item, section: section };
            }
        }
    }
    return undefined;
}
exports.findQuestionByRootId = findQuestionByRootId;
function findOrThrowQuestionByRootId(sections, rootId) {
    var res = findQuestionByRootId(sections, rootId);
    if (!res) {
        throw new Error("unable to find question by root id " + rootId);
    }
    return res;
}
exports.findOrThrowQuestionByRootId = findOrThrowQuestionByRootId;
function findQuestionById(sections, id) {
    for (var _i = 0, sections_2 = sections; _i < sections_2.length; _i++) {
        var section = sections_2[_i];
        for (var _a = 0, _b = section.items; _a < _b.length; _a++) {
            var item = _b[_a];
            if (item.id === id && types_1.isQuestionDTO(item)) {
                return { question: item, section: section };
            }
        }
    }
    return undefined;
}
exports.findQuestionById = findQuestionById;
function findOrThrowQuestionById(sections, id) {
    var res = findQuestionById(sections, id);
    if (!res) {
        throw new Error("unable to find question by id " + id);
    }
    return res;
}
exports.findOrThrowQuestionById = findOrThrowQuestionById;
function findAllQuestionsInSections(sections) {
    var questions = [];
    for (var _i = 0, sections_3 = sections; _i < sections_3.length; _i++) {
        var section = sections_3[_i];
        for (var _a = 0, _b = section.items; _a < _b.length; _a++) {
            var item = _b[_a];
            if (types_1.isQuestionDTO(item)) {
                questions.push(item);
            }
        }
    }
    return questions;
}
exports.findAllQuestionsInSections = findAllQuestionsInSections;
//# sourceMappingURL=findQuestion.js.map